import { render } from "./ComparedProduct.vue?vue&type=template&id=646eb12d"
import script from "./ComparedProduct.vue?vue&type=script&lang=js"
export * from "./ComparedProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/loans-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__